"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var PlayersLevelsList_1 = require("./component/PlayersLevelsList");
var PlayerLevelEditor_1 = require("./component/PlayerLevelEditor");
var PlayerLevelConfig_1 = require("./component/PlayerLevelConfig");
var PPlayerLevelsList = /** @class */ (function (_super) {
    __extends(PPlayerLevelsList, _super);
    function PPlayerLevelsList(props) {
        return _super.call(this, props) || this;
    }
    PPlayerLevelsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ avail_currency: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize,
                all_currency: data.all_currency,
                currency_id: data.currency_id
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            currency_id: this.props.state.getCurrencyId(),
            all_currency: this.props.state.getIsAllCurrency(),
            avail_currency: []
        }, function () {
            _this.props.listBrands.LoadData();
            _this.props.listAppCurrency.LoadData();
        });
    };
    PPlayerLevelsList.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
    };
    PPlayerLevelsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PPlayerLevelsList.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", record: item });
    };
    PPlayerLevelsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PPlayerLevelsList.prototype.onConfiglick = function (item) {
        this.setState({ edit_mode: "CONFIG", record: item });
    };
    PPlayerLevelsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PPlayerLevelsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PPlayerLevelsList.prototype.onCurrencyFilterChanged = function (allCurrency, CurrencyId) {
        this.props.state.setAllCurrency(allCurrency, true);
        this.props.state.setCurrencyId(CurrencyId, true);
    };
    PPlayerLevelsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(PlayerLevelEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), listBrands: this.props.listBrands }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(PlayerLevelEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), listBrands: this.props.listBrands }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(PlayersLevelsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onConfigClick: this.onConfiglick.bind(this), currencyId: this.state.currency_id, allCurrency: this.state.all_currency, availCurrency: this.state.avail_currency, onCurrencyFilterChanged: this.onCurrencyFilterChanged.bind(this) }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(PlayerLevelConfig_1.default, { dataLvlAttributes: this.props.dataLvlAttributes, dataLvlLocales: this.props.dataLvlLocales, dataLvlBetAmounts: this.props.dataLvlBetAmounts, dataLvlOffers: this.props.dataLvlOffers, listAvailAppLanguages: this.props.listAvailAppLanguages, listAvailAppCurrency: this.props.listAppCurrency, state: this.props.state, onGoBackClick: this.onGoBackClick.bind(this), record: this.state.record }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PPlayerLevelsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PPlayerLevelsList.getPageDescription = function (state) {
        return {
            icon: "trophy",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gift_levels + "-id",
            itemTitle: "Уровни игроков",
            route: routes_1.routes.page_gift_levels,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PPlayerLevelsList;
}(React.Component));
exports.default = PPlayerLevelsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/PPlayersLevelsList.tsx
// module id = 1946
// module chunks = 0